import React from 'react';
import './styles.css';

function hexToRgb(hex) {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return { r, g, b };
}

const legendItems = [
  { title: 'Muito Satisfeito', color: '#6EB44D' }, 
  { title: 'Satisfeito', color: '#B5DF66' },       
  { title: 'Neutro', color: '#FADB43' },           
  { title: 'Insatisfeito', color: '#F57A22' },     
  { title: 'Muito Insatisfeito', color: '#C63637' }, 
];

const MapLegend = () => {
  return (
    <div className="legend-container">
      {legendItems.map(item => {
        const rgb = hexToRgb(item.color);
        const dotStyle = {
          backgroundColor: `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, 0.7)`
        };
        return (
          <div key={item.title} className="legend-item">
            <span className="legend-color-dot" style={dotStyle}></span>
            <span className="legend-title">{item.title}</span>
          </div>
        );
      })}
    </div>
  );
};

export default MapLegend;